import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAnalysisGroup4 } from '../../entities/control-tables/product-analysis-group4-entity';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class ProductAnalysisGroup4Request extends BaseRequest {

    productAnalysisGroup4 : ProductAnalysisGroup4

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productAnalysisGroup4 = new ProductAnalysisGroup4()
  }
}